module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAADvSURBVHgBxZLfDYIwEMYvxGdYQCdwAcsA6gD+eTdOoBM4gQuoA1AG0AVUJmAAdACZwO/kSppa0BfjJb8A17uv37UQ/ShWIAd3cAJTsAQadD81b8DBKlQgAyMwA1fQb2pWUuDL55a7vVkInMIeOHsELqAUV9p2EHiKI/IHN99AKGJegSOI6X1Gtp1I81ocvaLjFLLyAqQiVlA1fyT5MVWHmRhHvhHM7lw8F0cPEeHGoayn4qgO/tCyoBxRvr7MyYdODW2p+geawjRoW8icgRIGLQKlL2kEeN4dtQfvHMu7eU7IZ+sLobrW3ALvXtA/4gllkyr1TKhCkwAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon/englishVoice/icon_check_addUser.png
// module id = KFyw
// module chunks = 4